import React from 'react';
import logo from 'assets/img/icons/th_ai_logo.png';
import classNames from 'classnames';

interface LogoProps {
  width?: number;
  height?: number;
  text?: boolean;
  textClass?: string;
  className?: string;
}
/*
const Logo = ({ width = 27, text = true, textClass, className }: LogoProps) => {
  return (
    <div className={classNames(className, 'd-flex align-items-center')}>
      <img src={logo} alt="phoenix" width={width} />
      {text && (
        <p className={classNames(textClass, 'logo-text ms-2')}>TH</p>
      )}
    </div>
  );
};
*/

const Logo = ({ height = 110, text = false, textClass, className }: LogoProps) => {
  return (
    <div className={classNames(className, 'd-flex align-items-center')}>
      <img src={logo} alt="phoenix" height={height} />
      {text && (
        <p className={classNames(textClass, 'logo-text ms-2')}>TH</p>
      )}
    </div>
  );
};

export default Logo;
